<template>
  <div v-if="!isLoadingInit">
    <div v-if="successInit">
      <div v-if="errorsVotingLimitRules.length > 0" class="sticky-voting-rules-errors">
        <b-alert :show="errorsVotingLimitRules.length > 0" variant="danger">
          Les règles de limite de vote ne sont pas acceptées.
          <b-button v-b-modal.modal-voting-limit-errors variant="outline-danger" class="mx-2">
            Informations
          </b-button>

          <b-modal id="modal-voting-limit-errors" size="lg" hide-footer>
            <appVotingLimitRulesErrors :errors-voting-limit-rules="errorsVotingLimitRules" />
          </b-modal>
        </b-alert>
      </div>
      <router-view :video="video" :errors-voting-limit-rules="errorsVotingLimitRules" />
    </div>
    <div v-else>
      <b-alert variant="danger" show>
        <h3>Erreur : quelque chose s'est mal passé</h3>
      </b-alert>
    </div>
  </div>
  <appLoader v-else />
</template>

<script>
import votingLimitRulesMixin from "@/mixins/voting-limit-rules";
import meetingDetailsMixin from "@/mixins/meeting-details";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";
import minutesMixin from "@/mixins/minutes.js";

import MeetingMW from "@/middlewares/Meeting";
import VotingCategoryMW from "@/middlewares/VotingCategory";
import MandateMW from "@/middlewares/Mandate";
import BuildingOwnerMW from "@/middlewares/BuildingOwner";
import ContactMW from "@/middlewares/Contact";
import BuildingLotMW from "@/middlewares/BuildingLot";
import MeetingResolutionMW from "@/middlewares/MeetingResolution";
import MajorityMW from "@/middlewares/Majority";

import MeetingORM from "@/store/orm-axios/models/Meeting";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import BuildingOwnerBuildingLotORM from "@/store/orm-axios/models/BuildingOwnerBuildingLot";
import BuildingOwnerVotingRightORM from "@/store/orm-axios/models/BuildingOwnerVotingRight";
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import ContactORM from "@/store/orm-axios/models/Contact";
import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";
import MeetingCorrespondenceVoteMW from "@/middlewares/MeetingCorrespondenceVote";
import BuildingMajoritiesMW from "@/middlewares/BuildingMajorities";

import { meetingMinutesNames } from "@/constants/meeting.js";

import appVotingLimitRulesErrors from "@/components/snippets/VotingLimitRulesErrors";

export default {
  components: {
    appVotingLimitRulesErrors,
  },
  mixins: [
    votingLimitRulesMixin,
    meetingPresenceSelectOptionsMixins,
    meetingDetailsMixin,
    minutesMixin,
  ],
  props: ["video"],
  data() {
    return {
      meetingMinutesNames,
      meeting: null,
      isLoadingInit: true,
      successInit: true,
    };
  },
  computed: {
    allMandatesGrouped() {
      var meetingMandates = MandateORM.getters("getMandatesForMeetingPresence")(this.meeting.id);
      var mandatesThatShowedUpOrIntendTo = this.$_.filter(meetingMandates, mandate => {
        return (
          mandate.showed_up == 1 ||
          mandate.presence_status == this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
        );
      });
      return this.$_.groupBy(mandatesThatShowedUpOrIntendTo, item => {
        if (item.representant_owner_id) return "owner-" + item.representant_owner_id;
        else if (item.representant_contact_id) return "contact-" + item.representant_contact_id;
      });
    },
    errorsVotingLimitRules() {
      if (!this.votingLimitRules.votingLimitIsActive) return [];

      var errors = [];

      for (let [key, xGroupedMandates] of Object.entries(this.allMandatesGrouped)) {
        var totalMandateVotes = xGroupedMandates.length;
        var totalUsedMandateTantiemesChargeGenerale = this.getMandatesTantiemesChargeGenerale(
          xGroupedMandates,
          true
        );

        // INFO: in case mandate has more tantiemes than the limit, but only by himself (and is building owner)
        var ignoreVotingIncludesMandateBiggerThanLimit = false;
        if (totalMandateVotes == 1) {
          if (xGroupedMandates[0].building_owner_id == xGroupedMandates[0].representant_owner_id) {
            ignoreVotingIncludesMandateBiggerThanLimit = true;
          }
        }

        // INFO: in case participant is owner, substract 1 mandate from sum (ignore his mandate)
        var participantIsOwner = !!this.$_.find(xGroupedMandates, function (xMandate) {
          return xMandate.building_owner_id == xMandate.representant_owner_id;
        });
        if (participantIsOwner) totalMandateVotes--;

        // check if passes limit rule
        if (this.votingLimitRules.votingLimitOperator == this.rulesOptions.rulesOperators.et) {
          if (
            totalMandateVotes > this.votingLimitRules.votesLimitPerMandate ||
            (totalUsedMandateTantiemesChargeGenerale >
              this.votingLimitRules.tantiemesLimitPerMandate &&
              !ignoreVotingIncludesMandateBiggerThanLimit)
          ) {
            xGroupedMandates[0]["errors"] = this.constructAndGetVotingLimitRulesErrors(
              totalMandateVotes,
              totalUsedMandateTantiemesChargeGenerale
            );
            errors.push(xGroupedMandates[0]);
          }
        } else if (
          this.votingLimitRules.votingLimitOperator == this.rulesOptions.rulesOperators.ou
        ) {
          if (
            totalMandateVotes > this.votingLimitRules.votesLimitPerMandate &&
            totalUsedMandateTantiemesChargeGenerale >
              this.votingLimitRules.tantiemesLimitPerMandate &&
            !ignoreVotingIncludesMandateBiggerThanLimit
          ) {
            xGroupedMandates[0]["errors"] = this.constructAndGetVotingLimitRulesErrors(
              totalMandateVotes,
              totalUsedMandateTantiemesChargeGenerale
            );
            errors.push(xGroupedMandates[0]);
          }
        }
      }

      return errors;
    },
  },
  async created() {
    try {
      await MeetingMW.GET(this.$route.params.id);

      this.meeting = MeetingORM.find(this.$route.params.id);
      const generalDetailsEvent = this.meeting.minutes.find(
        minute => minute.event == this.meetingMinutesNames.general_details
      );
      const hasFreezedMeetingDetails = !this.$_.isEmpty(this.meeting.freezed_meeting_details);

      // !!!: added a new property in meeting minutes objects: uuid.. this function is used so that the old meetings that don't have it set yet, would be updated
      await this.CHECK_IF_MINUTES_HAVE_UUIDS_SET(this.meeting);

      await this.makeApiCalls();
      // NOTE: get only needed data (because we use freezed meeting details data instead, if it's set)
      if (!generalDetailsEvent || !hasFreezedMeetingDetails) {
        await this.makeSecondaryApiCalls();
      }

      this.setVotingLimitRulesStoreVariables(generalDetailsEvent);
      this.setMeetingDetailsStoreVariables(hasFreezedMeetingDetails);

      this.successInit = true;
      this.isLoadingInit = false;
    } catch {
      this.successInit = false;
      this.isLoadingInit = false;
    }
  },
  beforeDestroy() {
    this.clearStore();
  },
  methods: {
    constructAndGetVotingLimitRulesErrors(
      totalMandateVotes,
      totalUsedMandateTantiemesChargeGenerale
    ) {
      var errors = [];

      if (totalMandateVotes > this.votingLimitRules.votesLimitPerMandate) {
        errors.push({ name: "mandats", value: totalMandateVotes });
      }
      if (
        totalUsedMandateTantiemesChargeGenerale > this.votingLimitRules.tantiemesLimitPerMandate
      ) {
        errors.push({
          name: "tantièmes",
          value: totalUsedMandateTantiemesChargeGenerale,
        });
      }

      return errors;
    },

    clearStore() {
      this.$store.commit("votingLimitRules/resetState");
      this.$store.commit("meetingDetails/resetState");

      MandateORM.deleteAll();
      MeetingResolutionORM.deleteAll();
      BuildingOwnerORM.deleteAll();
      BuildingOwnerBuildingLotORM.deleteAll();
      BuildingOwnerVotingRightORM.deleteAll();
      BuildingLotORM.deleteAll();
      ContactORM.deleteAll();
      VotingCategoryORM.deleteAll();
      ResolutionVoteORM.deleteAll();
    },

    // FIXME: .. might need changes/improvements regarding api calls -- unnecesary/duplicate data loaded
    makeApiCalls() {
      return Promise.all([
        MandateMW.FETCH_WITHOUT_RESOLUTION_VOTES(this.meeting.id),
        MajorityMW.FETCH(),
        MeetingCorrespondenceVoteMW.FETCH_BY_MEETING(this.meeting.id),
        BuildingMajoritiesMW.FETCH(this.meeting.building_id),
      ]);
    },
    makeSecondaryApiCalls() {
      return Promise.all([
        BuildingOwnerMW.FETCH(this.meeting.building_id), // ???: unnecesary -- they come with mandates
        BuildingLotMW.FETCH(this.meeting.building_id),
        ContactMW.FETCH(this.meeting.building_id),
        VotingCategoryMW.GET_BY_MEETING(this.meeting.id),
      ]);
    },
  },
};
</script>
